import { Component, OnInit, EventEmitter } from '@angular/core';
import { catchError, combineLatestAll, forkJoin, map, Observable, of, Subscription, switchMap, take } from 'rxjs';
import { ActionButtonEvent } from 'src/app/layout/action-button-toolbar/action-button-toolbar.component';
import { ColumnSetting } from 'src/app/layout/table-standard-layout/table-standard-layout.component';
import { MatDialog } from '@angular/material/dialog';

import moment from  'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';
import { AuthService } from 'src/app/services/auth.service';
import { User } from 'src/app/auth/user';
import { SystemService } from '../../services/system.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SystemInfoService } from '../../services/system-info.service';
import { SystemInfoPopup } from './system-info-popup/system-info-popup';
@Component({
  selector: 'app-system-info',
  templateUrl: './system-info.component.html',
  styleUrls: ['./system-info.component.css']
})
export class SystemInfoComponent implements OnInit {


  onSystemInfo: EventEmitter<ActionButtonEvent>;
  onSystemInfoSubscription: Subscription;
  systems = [
    {
      name: 'System 1',
      status: 'down',
      pingStatus: 'active',
      dockerStatus: 'inactive',
      networkStatus: '4g',
      nodes: [
        {
          name: 'Node A',
          issues: ['door_opened', 'light_on']
        },
        {
          name: 'Node B',
          issues: ['elevator_problem', 'channel_jammed']
        },
        {
          name: 'Node C',
          issues: ['door_opened', 'light_off']
        }
      ]
    },
    {
      name: 'System 2',
      status: 'active',
      pingStatus: 'inactive',
      dockerStatus: 'active',
      networkStatus: '4g',
      nodes: [
        {
          name: 'Node A',
          issues: ['light_on']
        },
        {
          name: 'Node B',
          issues: ['elevator_problem']
        }
      ]
    }
  ];
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };
  systems$ = new Observable()
  rowActionButtons: { icon: string; tooltip: string; eventEmitter: EventEmitter<ActionButtonEvent>; }[];

  columnSettings: ColumnSetting[] = [

    {
      columnId: 'number',
      name: 'Number',
    },
    {
      columnId: 'name',
      name: 'Name',
    },
    {
      columnId: 'lastPing',
      name: 'Last Ping',
    },
    {
      columnId: 'color',
      name: 'Color',
    },
    
  ]

  constructor(private authService: AuthService, private systemInfoService: SystemInfoService, private dialog: MatDialog) {

   
this.systems$ = this.systemInfoService.systemInfo().pipe(
  switchMap((systems: any[]) => {
    // if no systems, just emit empty array
    if (!systems || systems.length === 0) {
      return of([]);
    }

    // build one Observable per system that:
    //  - takes exactly one ping (take(1)) so it completes
    //  - maps into the enriched shape
    //  - catches errors so one failure doesn’t kill the whole forkJoin
    const enriched$ = systems.map(sys =>
      this.systemInfoService.getLastPing(sys.systemId).pipe(
        take(1),
        map((ping: any) => ({
          ...sys,
          ...ping,
        })),
        catchError(err => {
          console.error(`Failed to load ping for ${sys.dbid}`, err);
          return of({
            ...sys,
            lastPing: '--',
            status: '--'
          });
        })
      )
    );

    // forkJoin will now emit once, when every inner Observable has
    // emitted + completed.
    return forkJoin(enriched$).pipe(map((enriched: any[]) => {
      // map the enriched array into the shape we want
      return enriched.map((sys: any) => ({
        ...sys,
        ...sys['0'],
        lastPing: sys['0'] ? sys['0']['createdAt'].toDate().toLocaleString() : "--" ,
        color: sys['0'] ?sys['0']['status'] == "reachable" ? "GREEN" : "RED" : "--",

      }));
    }));
  })
);

this.systems$.subscribe((data: any[]) => {
  console.log('Enriched systems:', data);
});
    this.onSystemInfo = new EventEmitter<ActionButtonEvent>();


    this.rowActionButtons = [
      { icon: 'edit', tooltip: 'Edit', eventEmitter: this.onSystemInfo },
    ]

  }
  ngOnInit() {

    this.onSystemInfoSubscription = this.onSystemInfo.subscribe(event => {
      this.dialog.open(SystemInfoPopup, {
        disableClose: true,
        width: '850px',
        data: {
          ...event.eventData,
        }
      });
    });

    
  }


  getStatusIcon(status: string) {
    switch (status) {
      case 'active': return 'check_circle'; // Success
      case 'down': return 'cancel'; // Error
      case 'inactive': return 'pause_circle_filled'; // Warning
      case '4g': return 'network_wifi'; // Info
      default: return 'error';
    }
  }

  getIssueIcon(issue: string) {
    switch (issue) {
      case 'door_opened': return 'door_front'; 
      case 'light_on': return 'lightbulb'; 
      case 'elevator_problem': return 'elevator'; 
      case 'channel_jammed': return 'signal_wifi_off'; 
      default: return 'error';
    }
  }

  ngOnDestroy() {
    this.onSystemInfoSubscription.unsubscribe();
    // this.onUpdateCompanySubscription.unsubscribe()
  }
}

